export class AiJobDetails {
  constructor(
    public uid: string,
    public availabilityZoneId: number,
    public status: EAiJobStatus,
    public contentControlItemUid: string,
  ) {}
}

export enum EAiJobStatus {
  Created,
  Scheduled,
  Pending,
  Processing,
  Finished,
  Revoked,
  Error,
}
